var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deploy-backup-container"},[_vm._m(0),_vm._v(" "),_c('vertical-steps',{attrs:{"steps":_vm.steps}}),_vm._v(" "),(_vm.showDoneButton)?_c('app-button',{attrs:{"type":"primary"},on:{"click":_vm.close}},[_vm._v("Done")]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":"/static/images/backup_deploy.png","alt":"backup icon"}})])
}]

export { render, staticRenderFns }